import { render } from "./index.vue?vue&type=template&id=38d354d0&bindings={\"errors\":\"data\",\"files\":\"data\",\"handleFileChange\":\"options\",\"submit\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "38d354d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d354d0')) {
    api.reload('38d354d0', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=38d354d0&bindings={\"errors\":\"data\",\"files\":\"data\",\"handleFileChange\":\"options\",\"submit\":\"options\"}", () => {
    api.rerender('38d354d0', render)
  })

}

script.__file = "resources/js/Components/FileUploader/index.vue"

export default script